import Inicial from '../../spa/catalogo/catalogo';

export default {
    path: 'inicial/:idDepartamento?/:idSubDepartamento?/:descripcion?',
    name: 'inicial',
    component: Inicial,
    props: true
};


// WEBPACK FOOTER //
// ./src/config/router/inicial.js